import { ReactElement } from 'react';

import Richtext from '../../UI/Richtext';
import CTA from '../../UI/Cta';
import { Document } from '@contentful/rich-text-types';
import { IFragmentCta, IFragmentIFrameCta } from 'types/contentful';
import { LINK_CONTENT_TYPE } from 'lib/consts';
import IFrameCTA from 'components/UI/IFrameCta';

export interface SlimHeroProps {
  body?: Document | undefined;
  heading?: string | undefined;
  image: string;
  mobileImage?: string | null;
  cta?: IFragmentCta | IFragmentIFrameCta | undefined;
}

export default function SlimHero({
  body,
  heading,
  image,
  mobileImage,
  cta,
}: SlimHeroProps): ReactElement {
  const mobileSrc = mobileImage || image;

  return (
    <div className="relative min-h-slim-banner-mobile md:min-h-banner-desktop ecp-my">
      <div
        className="absolute inset-0 h-full bg-cover bg-center"
        style={{
          backgroundImage: `url(${image})`,
        }}
      />
      <div
        className="absolute inset-0 min-h-banner-mobile md:min-h-banner-desktop bg-cover bg-center md:hidden"
        style={{
          backgroundImage: `url(${mobileSrc})`,
        }}
      />
      <div className="md:w-1/2 h-1/2 md:h-full relative z-10 py-10 md:py-16 pl-site-component">
        <div className="h-full py-6 md:py-0 flex flex-col justify-center ml-auto z-20">
          <div className="flex justify-center text-center md:text-left">
            <h2 className="text-new-40 md:text-new-42 text-primary-actual">{heading}</h2>
          </div>
          {body && (
            <Richtext
              document={body}
              classNames="mt-2 text-center md:text-left text-lg font-light text-primary-actual"
            />
          )}
          <div className="w-full mt-8 mx-auto md:mx-0  max-w-400 md:w-3/4">
            {cta &&
              (cta.sys.contentType.sys.id === LINK_CONTENT_TYPE.fragmentIFrameCta ? (
                <IFrameCTA {...cta.fields} backgroundColor="black" classNames="w-full md:w-auto" />
              ) : (
                <CTA
                  {...cta.fields}
                  classNames="bg-white text-base button-text text-primary-actual w-full md:w-auto"
                />
              ))}
          </div>
        </div>
      </div>
    </div>
  );
}
